import React from 'react';

import ContentView from '../../components/ui-controls/layout/ContentView';
import FlatListMenu from '../../components/ui-controls/MenuFlatList';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';

const PromotionsScreen = ({
  navigation,
}: RouteNavigatorScreenProps<AppRoute.ACCOUNT_LOGGED_IN>) => {
  const handleMenuItemPress = (menuItems: any) =>
    navigation.navigate(menuItems.target);

  const menuItems = [
    {target: AppRoute.PROMOTIONS_CURRENT, name: 'Current Promotions'},
    {target: AppRoute.PROMOTIONS_WINNERS, name: 'Winners!'},
  ];

  return (
    <ContentView testID="promotions-screen">
      <FlatListMenu data={menuItems} onPressItem={handleMenuItemPress} />
    </ContentView>
  );
};

export default PromotionsScreen;
